import React from "react";
import { Route, Switch } from "react-router-dom";
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import routesData from "./routesData";

import { playTransition } from "../components/PageTransition";
import ErrorPage from "../pages/ErrorPage";

function Routes() {
  const handleExit = () => {
    playTransition();
  };
  return (
    <Route render={({ location }) => (
      <>
        <div className="transition-overlay">
          <h1 className="trans-heading">DC</h1>
          <div className="backgroundblur1"></div>
          <div className="backgroundblur2"></div>
        </div>
        <TransitionGroup>
          <CSSTransition key={location.key} timeout={1500} className="fade" onExit={handleExit}>
            <Switch location={location}>
              {routesData.map((data, index) => (
                <Route
                  exact
                  key={`route-index-${index}`}
                  path={data.pageURL}
                  component={() => <>{data.component}</>}
                />
              ))}
              <Route path="/" component={ErrorPage} />
            </Switch>
          </CSSTransition>
        </TransitionGroup>
      </>
    )} />
  );
}

export default Routes;
